<script>
import { McWysiwyg } from '@mycure/vue-wysiwyg';
import {mapGetters, mapActions} from 'vuex'
import stepsMixin from '../../../../mixins/stepsMixin'
import PfModal from '../PfModal.vue'
import PfLoader from '../PfLoader.vue'
import pfMixin from '../../../../mixins/pfMixin'
export default {
	mixins: [pfMixin, stepsMixin],
	components: {
		McWysiwyg,
		PfModal,
		PfLoader,
	},
	props: ['client', 'analysis', 'name'],

	data() {
		return {
			cliente: null,
			activeClient: null,
			datos: {
			},
			informesPendientes: [],
			modalNewAnalysis: {
				type: '',
				query: '',
				results: [],
				selectedClient: null,
				clientAnalysis: null
			},
			config: {
				events: {
					initialized: function () {
						console.log('initialized')
					}
				}
			},
			model: 'Edit Your Content Here!',
			hide: {
				strikethrough: true,
				table: true
			}
		}
	},

	computed: {
		totalAccionistas() {
			let total = 0

			this.datos.principales_accionistas.forEach(a => {
				total += Number(a.porcentaje)
			})

			return total
		},

		currentClient() {
			if(!this.activeClient) {
				return null
			}

			if(this.datos.hasOwnProperty('estructura')) {
				return  this.datos.estructura.find(item => item.id == this.activeClient)
			}
		},
		...mapGetters({
			pfSearch: 'pfClients/search',
			userId: 'auth/userId',
		})
	},

	watch: {
		client: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'cliente', newData)
				debugger
				let client = newData.datos
				client.hijos = newData.hijos
				this.$set(this.modalNewAnalysis, 'clientAnalysis', client)
			},
			deep: true,
			immediate: true
		},
		analysis: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'datos', {...newData.datos})
				debugger
				if(this.datos.hasOwnProperty('estructura')) {
					if(this.datos.estructura.length && this.activeClient == null) {
						this.activeClient = this.datos.estructura[0].id
					}
				} 
			},
			deep: true,
			immediate: true
		}
	},

	methods: {
		saveAnalysis() {
			let avance = this.calcAvance()
			this.save(avance)
		},
		calcAvance() {
			if(!this.datos.hasOwnProperty('estructura')) {
				return 0
			}
			let size = 0

			this.datos.estructura.forEach(item => {
				size += Object.keys(item.datos).length
			})

			let keyPercentage = 100 / size


			let total = 0
			console.log(size)
			let i = 0
			this.datos.estructura.forEach(item => {
				for (const key in item.datos) {
					if(item.datos[key] != '') {
						i += 1
						console.log(i)
						console.log(item.datos[key])
						total += keyPercentage
						console.log(total)
					} else {
						console.log('///////////////////////////////////////')
						console.log(key)
						console.log(item.datos[key])
						console.log('///////////////////////////////////////')

					}
				}
			})

			return total <= 100 ? Math.round(total) : 100
		},
		addToClient(event, item) {
			if(event.target.checked) {
				this.currentClient.datos.informes.push(item)
			} else {
				let index = this.currentClient.datos.informes.findIndex(i => i.ano == item.ano)

				this.currentClient.datos.informes.splice(index, 1)
			}
		},
		openAddAnalysis() {
			this.$refs.addAnalysis.open(null, this.$tours['pfFREG'].stop)

			this.showSteps('pfFREG')
		},
		submitSearch() {
			this.$set(this.modalNewAnalysis, 'selectedClient', null)
			this.$set(this.modalNewAnalysis, 'results', [])
			let results = JSON.stringify(this.pfSearch(this.modalNewAnalysis.query))
				results = JSON.parse(results)
			this.$set(this.modalNewAnalysis, 'results', results)
			this.goToStep('pfFREG', 2)
		},
		selectClient(c) {
			c = JSON.stringify(c)
			c = JSON.parse(c)
			this.$set(this.modalNewAnalysis, 'selectedClient', c)
			this.goToStep('pfFREG', 4)
		},
		openItem(event) {
			let target = event.currentTarget

			target.classList.add('open')
			this.goToStep('pfFREG', 5)

		},
		setClient(client) {
			let last = document.querySelector('.text.select')
			if(last) {
				last.classList.remove('select')
			}
			let target = event.currentTarget
			target.classList.add('select')

			this.$set(this.modalNewAnalysis, 'clientAnalysis', client)
			this.goToStep('pfFREG', 6)
		},
		resetNewAnalysis() {
			this.$set(this, 'modalNewAnalysis', {
				type: '',
				query: '',
				results: [],
				selectedClient: null,
				clientAnalysis: null
			})
		},

		addClientToAnalysis() {
			let vm = this
			let client = JSON.stringify(vm.modalNewAnalysis.clientAnalysis)
					client = JSON.parse(client)
				debugger
				client.datos =  {
					informes: [],
					consolidado: 'INDIVIDUAL',
					salvedades: '',
					auditor: '',
					divisa: 'Pesos Mexicanos',
					tipo_de_cambio_a_euro: '',
					tipo_de_cambio_dolar: '',
					comentario_perimetro_de_consolidacion_salvedades: '',
	
					balance_datos_en: 'Millones',
					balance_divisa: 'Pesos Mexicanos',
					// balance_datos: [],
					
					vencimiento_deuda_datos_en: 'Millones',
					vencimiento_deuda_divisa: 'Pesos Mexicanos',
					// vencimiento_deuda_datos: [],
					
					cuenta_resultados_datos_en: 'Millones',
					cuenta_resultados_divisa: 'Pesos Mexicanos',
					// cuenta_resultados_datos: [],
					
					cash_flow_datos_en: 'Millones',
					cash_flow_divisa: 'Pesos Mexicanos',
					// cash_flow_datos: [],
					
					magnitudes_ratios_datos_en: 'Millones',
					magnitudes_ratios_divisa: 'Pesos Mexicanos',
					// magnitudes_ratios_datos: [],
					
					comentarios_a_la_situacion_financiera_economica_y_valoracion_global: '',
					comentarios_sobre_cash_flow_magnitudes_y_ratios_flexibidad_y_liquidez: '',
	
					rating_datos: [
						{
							cabecera: '',
							score: '',
							escala_maestra: '',
							escala_larga: ''
						}
					],
					valoracion_del_rating_y_ajuste_del_rating: '',
	
					informacion_de_rating_local: [
						{
							nombre: '',
							numero_de_cte_pu: '',
							fecha_del_ejercicio: '',
							puntuacion_cuantitativa: '',
							puntuacion_cualitativa: '',
							puntuacion_total: '',
							escala_anterior: '',
							escala_actual: '',
						}
					],
	
					proyecciones_analisis_de_sensibilidad: ''
	
				}
				debugger
				vm.datos.estructura.push(client)
				vm.activeClient = client.id
		},

		addToAnalysis() {
			let vm = this
			debugger
			this.$refs.loaderModal.open(3000, function () {
				let client = JSON.stringify(vm.modalNewAnalysis.clientAnalysis)
					client = JSON.parse(client)
				debugger
				client.datos =  {
					informes: [],
					consolidado: 'INDIVIDUAL',
					salvedades: '',
					auditor: '',
					divisa: 'Pesos Mexicanos',
					tipo_de_cambio_a_euro: '',
					tipo_de_cambio_dolar: '',
					comentario_perimetro_de_consolidacion_salvedades: '',
	
					balance_datos_en: 'Millones',
					balance_divisa: 'Pesos Mexicanos',
					// balance_datos: [],
					
					vencimiento_deuda_datos_en: 'Millones',
					vencimiento_deuda_divisa: 'Pesos Mexicanos',
					// vencimiento_deuda_datos: [],
					
					cuenta_resultados_datos_en: 'Millones',
					cuenta_resultados_divisa: 'Pesos Mexicanos',
					// cuenta_resultados_datos: [],
					
					cash_flow_datos_en: 'Millones',
					cash_flow_divisa: 'Pesos Mexicanos',
					// cash_flow_datos: [],
					
					magnitudes_ratios_datos_en: 'Millones',
					magnitudes_ratios_divisa: 'Pesos Mexicanos',
					// magnitudes_ratios_datos: [],
					
					comentarios_a_la_situacion_financiera_economica_y_valoracion_global: '',
					comentarios_sobre_cash_flow_magnitudes_y_ratios_flexibidad_y_liquidez: '',
	
					rating_datos: [
						{
							cabecera: '',
							score: '',
							escala_maestra: '',
							escala_larga: ''
						}
					],
					valoracion_del_rating_y_ajuste_del_rating: '',
	
					informacion_de_rating_local: [
						{
							nombre: '',
							numero_de_cte_pu: '',
							fecha_del_ejercicio: '',
							puntuacion_cuantitativa: '',
							puntuacion_cualitativa: '',
							puntuacion_total: '',
							escala_anterior: '',
							escala_actual: '',
						}
					],
	
					proyecciones_analisis_de_sensibilidad: ''
	
				}
				debugger
				vm.datos.estructura.push(client)
				vm.activeClient = client.id
				vm.$refs.addAnalysis.close()
				vm.resetNewAnalysis()
				vm.$parent.updatedForms()
				vm.saveAnalysis()
				vm.showSteps('pfFRTabs')
			})

		},

		seletecTab(id) {
			this.activeClient = id
		},

		removeTab(index) {
			this.datos.estructura.splice(index, 1)
			this.$parent.updatedForms()
			if(this.datos.estructura.length > 0) {
				this.activeClient = this.datos.estructura[0].id
			}else {
				this.activeClient = null
			}
		},
		openBalanceModal() {
			let vm = this
			this.$refs.balanceModal.open(null, function () {
				vm.goToStep('pfFRTabs', 4)
			})
			this.goToStep('pfFRTabs', 2)
		},

		uploadBalance() {
			this.$refs.balanceModal.close()
			this.$refs.loaderModal.open(2000, null)
			this.saveAnalysis()
			this.goToStep('pfFRTabs', 4)
		},

		getTitles(report) {

		},

		calcBase(datos, index) {
			
			let item = datos[index]
			let baseItem = datos[item.base]
			
			if(baseItem) {
				if((baseItem.monto * 1)) {
					return ((Number(item.monto)/Number(baseItem.monto)) *  100).toFixed(2) || 0
				}
				return 0
			}
			return 0
		},

		calcDeudaTotal(datos, indexs) {
			let total = 0

			indexs.forEach(item => {
				total = Number(total) + Number(datos[item].monto)
			})

			return total
		},
		
		calcDeudaNeta(datos, indexs, dt) {
			let deudaTotal = this.calcDeudaTotal(datos, dt)
			return( deudaTotal - Number(datos[indexs].monto)) > 0 ? (deudaTotal - Number(datos[indexs].monto)) : 0
		},
	
		calcDeudaNetaEbitda(datos, indexs, dt, dn) {
			let deudaNeta = this.calcDeudaNeta(datos, dn, dt)
			let ebitda = datos[indexs].monto

			if(ebitda > 0) {
				if(deudaNeta / Number(ebitda) > 0) {
					return (deudaNeta / Number(ebitda)).toFixed(2) || 'NEG'
				}
			}

			return 'NEG'
		},
		
		calcDeudaTotalEbitda(datos, indexs, dt) {
			let deudaTotal = this.calcDeudaTotal(datos, dt)
			let ebitda = datos[indexs].monto

			if(ebitda > 0) {
				return (deudaTotal / ebitda).toFixed(2) || 'NEG'
			}

			return 'NEG'
		},

		calcIndicadorCV(datos, formulas) {
			if((Number(datos[formulas.cartera_vigente].monto) + Number(datos[formulas.cartera_vencida].monto))) {
				return ((Number(datos[formulas.cartera_vencida].monto) / (Number(datos[formulas.cartera_vigente].monto) + Number(datos[formulas.cartera_vencida].monto))) * 100).toFixed(2)
			}
			return 0
		},

		calcCoberturaCV(datos, formulas) {
			if(Number(datos[formulas.cartera_vencida].monto)) {

				return ((Math.abs(Number(datos[formulas.estimacion_riesgo].monto)) / Number(datos[formulas.cartera_vencida].monto)) * 100).toFixed(2)
			}

			return 0
		},
		
	}
}
</script>
<template>
	<div class="pb-5">
		<div class="pf-analysis__header py-3">
			<div class="d-flex align-items-center">
				<span class="pf-tag pf-tag--success">{{cliente.estado}}</span> 
				<h4 class="mb-0">{{cliente.datos.nombre}}</h4>
				<!-- <button @click="$refs.loaderModal.open(3000)">showLoader</button> -->
			</div>
			<div class="ml-auto">
				<h5 class="mb-0">Renovación del PF: {{cliente.datos.nombre}}</h5>
			</div>
		</div>
	
		<div class="d-flex align-items-center py-3" data-v-step="pf_rf_0">
			<div class="d-flex align-items-center">
				<h4 class="">Financial Risk</h4>
			</div>
			<div class="ml-auto">
				<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="saveAnalysis"> <span class="icon-computer-folder"></span> Guardar</button>
			</div>
			
		</div>
		<div class="pf-fr-tabs" data-v-step="pf_rf_tabs_0">
			<div class="pf-fr-tab" :class="{'active': activeClient == client.id}" v-for="(client, index) in datos.estructura" :key="`cliente_estructura_${index}`" @click.stop="seletecTab(client.id)">
				<span class="pf-fr-tab__title">
					{{client.nombre}}
				</span>
				<span class="pf-fr-tab__close" v-if="index != 0" @click.stop="removeTab(index)" >
					X
				</span>
 
				<button v-if="activeClient == client.id" @click.stop="openBalanceModal" class="btn btn-sm btn-primary" data-v-step="pf_rf_tabs_1"><span class="icon-search"></span></button>
			</div>
			<button class="pf-fr-tab ml-1" @click="openAddAnalysis" data-v-step="pf_rf_1">
				+
			</button>
		</div>


		


		<div v-for="(client, index) in datos.estructura" :key="`cliente_estructura_panel_${index}`">
			<div :id="`accordion_fr_${index}`" v-if="activeClient == client.id" class="pf-accordion  pb-3">
				<div class="card">
					<div class="card-header p-1" :id="`fr_h_${index}_1`" data-v-step="pf_rf_tabs_4">
						<button class="btn btn-link d-block btn-block p-0 text-left" data-toggle="collapse" :data-target="`#fr_${index}_1`" aria-expanded="true" :aria-controls="`fr_${index}_1`">
							Síntesis económico financiera
						</button>
					</div>

					<div :id="`fr_${index}_1`" class="collapse show " :aria-labelledby="`fr_h_${index}_1`" :data-parent="`#accordion_fr_${index}`">
						<div class="pt-5">
							<div class="d-flex flex-wrap">
								<div class="col-12 col-lg-3">
									<label class="pf-control">
										<span class="pf-control__label">Consolidado</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<input class="pf-control__input pf-control--block" name="" v-model="client.datos.consolidado">
									</label>	
								</div>
							</div>
							<div class="d-flex flex-wrap">
								<div class="col-12 col-lg-3">
									<label class="pf-control">
										<span class="pf-control__label">Salvedades</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<input class="pf-control__input pf-control--block" name="" v-model="client.datos.salvedades">
									</label>	
								</div>
							</div>
							<div class="d-flex flex-wrap">
								<div class="col-12 col-lg-3">
									<label class="pf-control">
										<span class="pf-control__label">Auditor</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<input class="pf-control__input pf-control--block" name="" v-model="client.datos.auditor">
									</label>	
								</div>
							</div>
							<div class="d-flex flex-wrap">
								<div class="col-12 col-lg-3">
									<label class="pf-control">
										<span class="pf-control__label">Divisa</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<select class="pf-control__input pf-control--block" name="" v-model="client.datos.divisa">
											<option value=""></option>
											<option value="Euros">Euros</option>
											<option value="Pesos Mexicanos">Pesos Mexicanos</option>
											<option value="Dólares">Dólares</option>
											<option value="Yuan">Yuan</option>
										</select>
									</label>	
								</div>
							</div>
							<div class="d-flex flex-wrap">
								<div class="col-12 col-lg-3">
									<label class="pf-control">
										<span class="pf-control__label">Tipo de cambio a euro (€)</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<input class="pf-control__input pf-control--block" name="" v-model="client.datos.tipo_de_cambio_a_euro">
									</label>	
								</div>
							</div>
							<div class="d-flex flex-wrap">
								<div class="col-12 col-lg-3">
									<label class="pf-control">
										<span class="pf-control__label">Tipo de cambio ($)</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<input class="pf-control__input pf-control--block" name="" v-model="client.datos.tipo_de_cambio_dolar">
									</label>	
								</div>
							</div>
							<div class="d-flex flex-wrap">
								<div class="col-12 mx-auto">
									<label class="pf-control d-flex">
										<span class="pf-control__label">Comentarios perímetro de consolidación y Salvedades:</span>
										<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
									</label>	
									<quill-editor
									ref="myQuillEditor"
									v-model="client.datos.comentario_perimetro_de_consolidacion_salvedades"
									@change="$parent.updatedForms"
									/>
								</div>	
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-1" :id="`fr_h_${index}_2`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#fr_${index}_2`" aria-expanded="true" :aria-controls="`fr_${index}_2`">
							Balance
						</button>
					</div>

					<div :id="`fr_${index}_2`" class="collapse" :aria-labelledby="`fr_h_${index}_2`" :data-parent="`#accordion_fr_${index}`">
						<div class="d-flex flex-wrap pt-5">
							<div class="col-12 col-lg-3">
								<label class="pf-control">
									<span class="pf-control__label">Datos en</span>
									<!-- TODO listas desde caratula de los cobos select -->
									<select class="pf-control__input pf-control--block" name="" :value="client.datos.balance_datos_en" disabled>
										<option value=""></option>
										<option value="Miles">Miles</option>
										<option value="Millones">Millones</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-lg-3">
								<label class="pf-control">
									<span class="pf-control__label">Divisa</span>
									<!-- TODO listas desde caratula de los cobos select -->
									<select class="pf-control__input pf-control--block" name="" :value="client.datos.balance_divisa" disabled>
										<option value=""></option>
										<option value="Euros">Euros</option>
										<option value="Pesos Mexicanos">Pesos Mexicanos</option>
										<option value="Dólares">Dólares</option>
									</select>
								</label>	
							</div>
							<div class="col-6 text-right">
								<a href="#" style="color: black; text-decoration:underline;font-size:0.8rem;">Global Risk Analyst (RA)</a>
							</div>

							<div v-if="client.datos.informes.length" class="col-12 mt-5">
								<table class="table pf-table-th-gray" v-if="client.datos.informes[0].balance">
									<tr>
										<th>

										</th>
										<template  v-for="(reporte, index) in client.datos.informes">
											<th :key="`reporte_${index}`">
												{{reporte.fecha}}
											</th>
											<th :key="`reporte_p_${index}`">

												%
											</th>
										</template>
									</tr>
									<tr>
										<td>
											<span class="text-primary">ACTIVOS</span>
										</td>
									</tr>
									<tr v-for="(item, index) in client.datos.informes[0].balance.activo" :key="`reporte_r_${index}`">
										<td class="py-1">
											{{item.titulo}}
										</td>
										<template  v-for="(reporte, index2) in client.datos.informes">
											<td class="py-1 text-right" :key="`reporte_${index2}`" style="color: #ccc">
												{{(client.datos.informes[index2].balance.activo[index] ? client.datos.informes[index2].balance.activo[index].monto : '') | numeral('0,0')}}
											</td>
											<td class="py-1 text-right" :key="`reporte_p_${index2}`" style="color: #ccc">
												{{client.datos.informes[index2].balance.activo[index] ? client.datos.informes[index2].balance.activo[index].porcentaje : ''}}
											</td>
										</template>
									</tr>
									<tr>
										<td>
											<span class="text-primary">PASIVOS</span>
										</td>
									</tr>
									<tr v-for="(item, index) in client.datos.informes[0].balance.pasivo" :key="`reporte__p_r_${index}`">
										<td class="py-1">
											{{item.titulo}}
										</td>
										<template  v-for="(reporte, index2) in client.datos.informes">
											<td class="py-1 text-right" :key="`reporte_p_${index2}`" style="color: #ccc">
												{{(client.datos.informes[index2].balance.pasivo[index] ? (client.datos.informes[index2].balance.pasivo[index].monto ) : '' ) | numeral('0,0')}}
											</td>
											<td class="py-1 text-right" :key="`reporte_p_p_${index2}`" style="color: #ccc">
												{{client.datos.informes[index2].balance.pasivo[index] ? client.datos.informes[index2].balance.pasivo[index].porcentaje : ''}}
											</td>
										</template>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-1" :id="`fr_h_${index}_3`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#fr_${index}_3`" aria-expanded="true" :aria-controls="`fr_${index}_3`">
							Cuenta de resultados
						</button>
					</div>

					<div :id="`fr_${index}_3`" class="collapse" :aria-labelledby="`fr_h_${index}_3`" :data-parent="`#accordion_fr_${index}`">
						<div class="d-flex flex-wrap pt-5">
							<div class="col-12 col-lg-3">
								<label class="pf-control">
									<span class="pf-control__label">Datos en</span>
									<!-- TODO listas desde caratula de los cobos select -->
									<select class="pf-control__input pf-control--block" name="" :value="client.datos.cuenta_resultados_datos_en" disabled>
										<option value=""></option>
										<option value="Miles">Miles</option>
										<option value="Millones">Millones</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-lg-3">
								<label class="pf-control">
									<span class="pf-control__label">Divisa</span>
									<!-- TODO listas desde caratula de los cobos select -->
									<select class="pf-control__input pf-control--block" name="" :value="client.datos.cuenta_resultados_divisa" disabled>
										<option value=""></option>
										<option value="Euros">Euros</option>
										<option value="Pesos Mexicanos">Pesos Mexicanos</option>
										<option value="Dólares">Dólares</option>
									</select>
								</label>	
							</div>
							<div class="col-6 text-right">
								<a href="#" style="color: black; text-decoration:underline;font-size:0.8rem;">Global Risk Analyst (RA)</a>
							</div>

							<div v-if="client.datos.informes.length" class="col-12 mt-5">
								<table class="table pf-table-th-gray">
									<tr>
										<th>

										</th>
										<template  v-for="(reporte, index) in client.datos.informes">
											<th :key="`reporte_${index}`">
												{{reporte.fecha}}
											</th>
											<th class="text-right" :key="`reporte_p_${index}`">

												%
											</th>
										</template>
									</tr>
										<tr v-for="(item, index) in client.datos.informes[0].cuenta_resultados" :key="`reporte_r_cr_${index}`">
											<td class="py-1">
												{{item.titulo}}
											</td>
											<template  v-for="(reporte, index2) in client.datos.informes">
												<td  class="py-1 text-right" :key="`reporte_cr_${index2}`" style="color: #ccc">
													<span v-if="client.tipo != 'Filial'">
														{{client.datos.informes[index2].cuenta_resultados[index].monto | numeral('0,0.00')}}
													</span>
													<input v-else type="text" class="text-right" v-model="client.datos.informes[index2].cuenta_resultados[index].monto">
												</td>
												<td class="py-1 text-right" :key="`reporte_p_cr_${index2}`" style="color: #ccc">
													<!-- {{client.datos.informes[index2].cuenta_resultados[index].porcentaje}} -->
													{{calcBase(client.datos.informes[index2].cuenta_resultados, index)}}%
												</td>
											</template>
										</tr>
										
										<tr span v-if="client.tipo =='Filial'">
											<td>
												Deuda Total
											</td>
											<template  v-for="(reporte, index2) in client.datos.informes">
												<td  :key="`reporte_p_dt_${index2}`" class="text-right">
													<span v-if="client.datos.informes[index2].formulas">
														{{calcDeudaTotal(client.datos.informes[index2].cuenta_resultados, client.datos.informes[index2].formulas.deuda_total)}}
													</span>
												</td>
												<td  :key="`reporte_p_dtm_${index2}`"></td>
											</template>
										</tr>
										<tr span v-if="client.tipo =='Filial'">
											<td>
												Deuda Neta
											</td>
											<template  v-for="(reporte, index2) in client.datos.informes">
												<td  :key="`reporte_p_dt_${index2}`" class="text-right">
													<span v-if="client.datos.informes[index2].formulas">
														{{calcDeudaNeta(client.datos.informes[index2].cuenta_resultados, client.datos.informes[index2].formulas.deuda_neta, client.datos.informes[index2].formulas.deuda_total)}}
													</span>
												</td>
												<td  :key="`reporte_p_dtm_${index2}`"></td>
											</template>
										</tr>
										<tr span v-if="client.tipo =='Filial' && client.datos.informes[0].formulas.hasOwnProperty('deuda_total_ebitda')">
											<td>
												Deuda Total / EBITDA
											</td>
											<template  v-for="(reporte, index2) in client.datos.informes">
												<td  :key="`reporte_p_dt_${index2}`" class="text-right">
													<span v-if="client.datos.informes[index2].formulas">
														{{calcDeudaTotalEbitda(client.datos.informes[index2].cuenta_resultados, client.datos.informes[index2].formulas.deuda_total_ebitda, client.datos.informes[index2].formulas.deuda_total)}}
													</span>
												</td>
												<td  :key="`reporte_p_dtm_${index2}`"></td>
											</template>
										</tr>
										<tr span v-if="client.tipo =='Filial' && client.datos.informes[0].formulas.hasOwnProperty('deuda_neta_ebitda')">
											<td>
												Deuda Neta / EBITDA
											</td>
											<template  v-for="(reporte, index2) in client.datos.informes">
												<td  :key="`reporte_p_dt_${index2}`" class="text-right">
													<span v-if="client.datos.informes[index2].formulas">
														{{calcDeudaNetaEbitda(client.datos.informes[index2].cuenta_resultados, client.datos.informes[index2].formulas.deuda_total_ebitda, client.datos.informes[index2].formulas.deuda_total, client.datos.informes[index2].formulas.deuda_neta)}}
													</span>
												</td>
												<td  :key="`reporte_p_dtm_${index2}`"></td>
											</template>
										</tr>
										<tr span v-if="client.tipo =='Filial' && client.datos.informes[0].formulas.hasOwnProperty('cartera_vencida') && client.datos.informes[0].formulas.hasOwnProperty('cartera_vigente')">
											<td>
												Indicador CV
											</td>
											<template  v-for="(reporte, index2) in client.datos.informes">
												<td  :key="`reporte_p_dt_${index2}`" class="text-right">
													<span v-if="client.datos.informes[index2].formulas">
														{{calcIndicadorCV(client.datos.informes[index2].cuenta_resultados, client.datos.informes[index2].formulas)}}%
													</span>
												</td>
												<td  :key="`reporte_p_dtm_${index2}`"></td>
											</template>
										</tr>
										<tr span v-if="client.tipo =='Filial' && client.datos.informes[0].formulas.hasOwnProperty('cartera_vencida') && client.datos.informes[0].formulas.hasOwnProperty('estimacion_riesgo')">
											<td>
												Cobertura de CV
											</td>
											<template  v-for="(reporte, index2) in client.datos.informes">
												<td  :key="`reporte_p_dt_${index2}`" class="text-right">
													<span v-if="client.datos.informes[index2].formulas">
														{{calcCoberturaCV(client.datos.informes[index2].cuenta_resultados, client.datos.informes[index2].formulas)}}%
													</span>
												</td>
												<td  :key="`reporte_p_dtm_${index2}`"></td>
											</template>
										</tr>
								</table>
							</div>
							<div v-if="client.hasOwnProperty('extra')" class="col-12">
								<table class="table pf-table-th-gray">
									<tr>
										<th></th>
										<th></th>
										<th v-for="(ano, index) in client.extra[0].anos" :key="`extra_${index}`">
											{{ano}}
										</th>
									</tr>
									<tr v-for="(item, index) in client.extra" :key="`row_extra_${index}`">
										<td style="max-width: 300px">{{item.titulo}}</td>
										<td class="small" style="max-width: 200px">{{item.formula}}</td>
										<td v-for="(d,index2) in client.extra[index].datos" :key="`row_datos_${index2}`">
											{{d}}
										</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="d-flex flex-wrap pt-5">
							<div class="col-12 col-lg-3">
								<label class="pf-control">
									<span class="pf-control__label">Datos en</span>
									<!-- TODO listas desde caratula de los cobos select -->
									<select class="pf-control__input pf-control--block" name="" :value="client.datos.cash_flow_datos_en" disabled>
										<option value=""></option>
										<option value="Miles">Miles</option>
										<option value="Millones">Millones</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-lg-3">
								<label class="pf-control">
									<span class="pf-control__label">Divisa</span>
									<!-- TODO listas desde caratula de los cobos select -->
									<select class="pf-control__input pf-control--block" name="" :value="client.datos.cash_flow_divisa" disabled>
										<option value=""></option>
										<option value="Euros">Euros</option>
										<option value="Pesos Mexicanos">Pesos Mexicanos</option>
										<option value="Dólares">Dólares</option>
									</select>
								</label>	
							</div>
							<div class="col-6 text-right">
							</div>

							<div v-if="client.cash_flow.length" class="col-12 mt-5">
								<table class="table pf-table-th-gray" >
									<tr>
										<th>

										</th>
										<template  v-for="(reporte, index) in client.cash_flow">
											<th :key="`reporte_${index}`" class="text-right">
												{{reporte.ano}}
											</th>
										</template>
									</tr>
								
									<tr v-for="(item, index) in client.cash_flow[0].datos" :key="`reporte_r_cf_${index}`">
										<td class="py-1">
											{{item.titulo}}
										</td>
										<template  v-for="(reporte, index2) in client.cash_flow">
											<td class="py-1 text-right" :key="`reporte_cf_${index2}`" style="color: #ccc">
												{{client.cash_flow[index2].datos[index].monto | numeral('0,0')}}
											</td>
										</template>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-1" :id="`fr_h_${index}_4`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#fr_${index}_4`" aria-expanded="true" :aria-controls="`fr_${index}_4`">
							Magnitudes y Ratios
						</button>
					</div>

					<div :id="`fr_${index}_4`" class="collapse" :aria-labelledby="`fr_h_${index}_4`" :data-parent="`#accordion_fr_${index}`">
						<div class="d-flex flex-wrap pt-5">
							<div class="col-12 col-lg-3">
								<label class="pf-control">
									<span class="pf-control__label">Datos en</span>
									<!-- TODO listas desde caratula de los cobos select -->
									<select class="pf-control__input pf-control--block" name="" :value="client.datos.magnitudes_ratios_datos_en" disabled>
										<option value=""></option>
										<option value="Miles">Miles</option>
										<option value="Millones">Millones</option>
									</select>
								</label>	
							</div>
							<div class="col-12 col-lg-3">
								<label class="pf-control">
									<span class="pf-control__label">Divisa</span>
									<!-- TODO listas desde caratula de los cobos select -->
									<select class="pf-control__input pf-control--block" name="" :value="client.datos.magnitudes_ratios_divisa" disabled>
										<option value=""></option>
										<option value="Euros">Euros</option>
										<option value="Pesos Mexicanos">Pesos Mexicanos</option>
										<option value="Dólares">Dólares</option>
									</select>
								</label>	
							</div>
							<div class="col-6 text-right">
							</div>
							<div v-if="client.magnitudes_y_ratios.length" class="col-12 mt-5">
								<table class="table pf-table-th-gray">
									<tr>
										<th>

										</th>
										<template  v-for="(reporte, index) in client.magnitudes_y_ratios">
											<th :key="`reporte_${index}`" class="text-right">
												12/{{reporte.ano}}
											</th>
											<!-- <th :key="`reporte_p_${index}`">

												%
											</th> -->
										</template>
									</tr>
									<tr v-for="(item, index) in client.magnitudes_y_ratios[0].datos" :key="`reporte_r_mr_${index}`">
										<td class="py-1">
											{{item.titulo}}
										</td>
										<template  v-for="(reporte, index2) in client.magnitudes_y_ratios">
											<td class="py-1 text-right" :key="`reporte_mr_${index2}`" style="color: #ccc">
												{{client.magnitudes_y_ratios[index2].datos[index].monto | numeral('0,0')}}
											</td>
										</template>
									</tr>
								
								</table>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-1" :id="`fr_h_${index}_5`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#fr_${index}_5`" aria-expanded="true" :aria-controls="`fr_${index}_5`">
							Comentarios
						</button>
					</div>

					<div :id="`fr_${index}_5`" class="collapse" :aria-labelledby="`fr_h_${index}_5`" :data-parent="`#accordion_fr_${index}`">
						<div class="d-flex flex-wrap pt-5">
							<div class="col-12 mx-auto py-2">
								<label class="pf-control d-flex">
									<span class="pf-control__label">Comentarios a la situación financiera, economica y valoración global</span>
									<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
								</label>	
								<quill-editor
								ref="myQuillEditor"
								v-model="client.datos.comentarios_a_la_situacion_financiera_economica_y_valoracion_global"
								@change="$parent.updatedForms"
								/>
							</div>	
							<div class="col-12 mx-auto py-2">
								<label class="pf-control d-flex">
									<span class="pf-control__label">Comentarios sobre cash-flow, magnitudes y ratios, flexibilidad financiera y liquidez</span>
									<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
								</label>	
								<quill-editor
								ref="myQuillEditor"
								v-model="client.datos.comentarios_sobre_cash_flow_magnitudes_y_ratios_flexibidad_y_liquidez"
								@change="$parent.updatedForms"
								/>
							</div>	
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-1" :id="`fr_h_${index}_6`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#fr_${index}_6`" aria-expanded="true" :aria-controls="`fr_${index}_6`">
							Rating
						</button>
					</div>

					<div :id="`fr_${index}_6`" class="collapse" :aria-labelledby="`fr_h_${index}_6`" :data-parent="`#accordion_fr_${index}`">
						<div class="d-flex flex-wrap pt-5">
							<div class="col-12" v-if="client.rating.length">
								<div class="text-right py-1">
									<button class="btn btn-light btn-sm rounded-0 font-weight-bold"><span class="icon-refresh"></span> Actualizar</button>
								</div>
								<table class="table pf-table-th-gray" >
									<tr>
										<th></th>
										<th v-for="(r, index) in client.rating" :key="`r_${index}`">
											12/<input class="pf-control__transparent" type="number" v-model="r.ano">
										</th>
									</tr>
									<tr>
										<td class="py-1">
											Score
										</td>
										<td class="py-1" v-for="(r, index) in client.rating" :key="`r_s_${index}`">
											<input class="text-right pf-control__input pf-control--block" style="width: 100px" type="text" v-model="r.score">
										</td>
									</tr>
									<tr>
										<td class="py-1">
											ESCALA MAESTRA
										</td>
										<td class="py-1" v-for="(r, index) in client.rating" :key="`r_em_${index}`">
											<input class="pf-control__input pf-control--block" style="width: 120px" type="text" v-model="r.escala_maestra">
										</td>
									</tr>
									<tr>
										<td class="py-1">
											Escala Larga
										</td>
										<td class="py-1" v-for="(r, index) in client.rating" :key="`r_el_${index}`">
											<input class="pf-control__input pf-control--block" style="width: 120px" type="text" v-model="r.escala_larga">
										</td>
									</tr>
								</table>
							</div>
							<div class="col-12 mx-auto py-2">
								<label class="pf-control d-flex">
									<span class="pf-control__label">Valoración del rating y ajuste del rating</span>
									<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
								</label>	
								<quill-editor
								ref="myQuillEditor"
								v-model="client.datos.valoracion_del_rating_y_ajuste_del_rating"
								@change="$parent.updatedForms"
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-1" :id="`fr_h_${index}_7`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#fr_${index}_7`" aria-expanded="true" :aria-controls="`fr_${index}_7`">
							Información de Rating Local
						</button>
					</div>

					<div :id="`fr_${index}_7`" class="collapse" :aria-labelledby="`fr_h_${index}_7`" :data-parent="`#accordion_fr_${index}`">
						<div class="d-flex flex-wrap" >
							<div class="col-12 py-2" >
								<div style="overflow: auto">
									<table class="table pf-table-th-gray">
										<tr>
											<th class="text-center" colspan="2">INFORMACIÓN DE RATING LOCAL</th>
											<td colspan="4" style="border: 0"></td>
											<th class="text-center" colspan="2">
												<div class="d-flex">
													<input type="text">
													<span class="ml-auto">RESERVAS DEL GRUPO</span>
												</div>
											</th>

										</tr>
										<tr>
											<th class="text-center">NOMBRE</th>
											<th class="text-center">NÚMERO DE CTE. PU.</th>
											<th class="text-center">FECHA EJERCICIO</th>
											<th class="text-center">PUNTUACIÓN CUANTITATIVA</th>
											<th class="text-center">PUNTUACIÓN CUALITATIVA</th>
											<th class="text-center">PUNTUACIÓN TOTAL</th>
											<th class="text-center">ESCALA ACTUAL</th>
											<th class="text-center">ESCALA ANTERIOR</th>
										</tr>
										<template v-if="client.rating_local.length">
											<tr v-for="(rl, index) in client.rating_local" :key="`rl_${index}`">
												<td class="py-1 px-1"> 
													<div class="d-flex">
														<button class="btn btn-light p-1 text-primary mr-2"><span class="icon-trash"></span></button>
														<input type="text" style="width: 300px" v-model="rl.nombre" disabled>
														<button class="btn btn-sm btn-primary p-1 ml-2"><span class="icon-search"></span></button>
													</div>
												</td>
												<td class="py-1 px-1"> 
													<input style="width: 80px" type="" disabled>
												</td>
												<td class="py-1 px-1"> 
													<input class="px-1" style="width: 150px" type="date" v-model="rl.fecha" >
												</td>
												<td class="py-1 px-1"> 
													<input type="text" v-model="rl.puntuacion_cuantitativa" >
												</td>
												<td class="py-1 px-1"> 
													<input type="text" v-model="rl.puntuacion_cualitativa" >
												</td>
												<td class="py-1 px-1"> 
													<input type="text" v-model="rl.puntuacion_tital" >
												</td>
												<td class="py-1 px-1"> 
													<input type="text" v-model="rl.escala_actual" >
												</td>
												<td class="py-1 px-1"> 
													<input type="text" v-model="rl.escala_anterior" >
												</td>
											</tr>
										</template>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="card">
					<div class="card-header p-1" :id="`fr_h_${index}_9`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#fr_${index}_9`" aria-expanded="true" :aria-controls="`fr_${index}_9`">
							Proyecciones/Análisis de Sensibilidad
						</button>
					</div>

					<div :id="`fr_${index}_9`" class="collapse" :aria-labelledby="`fr_h_${index}_9`" :data-parent="`#accordion_fr_${index}`">
						<div class="d-flex flex-wrap pt-5">
							<div class="col-12 mx-auto py-2">
								<label class="pf-control d-flex">
									<span class="pf-control__label">Proyecciones/Análisis de Sensibilidad</span>
									<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
								</label>	
								<quill-editor
								ref="myQuillEditor"
								v-model="client.datos.proyecciones_analisis_de_sensibilidad"
								@change="$parent.updatedForms"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="pf-controls-flow">
			<div class="container">
				<div class="d-flex">
					<div class="ml-auto pf-controls-flow__button">
						<button class="btn btn-light btn-sm rounded-0 font-weight-bold"  @click="saveAnalysis"> <span class="icon-computer-folder"></span> Guardar</button>
					</div>
				</div>
			</div>
		</div>
		<pf-modal ref="balanceModal" :show-close="true" title="" class="pf-modal--md">
			<div v-if="currentClient" class="d-flex flex-wrap align-items-center">
				<div class="col-12 col-md-4">
					<label class="pf-control">
						<span class="pf-control__label">Cliente seleccionado</span>
						<input class="pf-control__input pf-control--block" name=""  :value="currentClient.nombre">
					</label>	
				</div>
				<div class="col-12 col-md-4">
					<label class="pf-control">
						<span class="pf-control__label">Fuente de aprovisionamiento</span>
						<select class="pf-control__input pf-control--block" name="" id="">
							<option value="Global RA">Global RA</option>
						</select>
					</label>	
				</div>
				<div class="col-12 col-md-4">
					<button class="pf-btn btn btn-primary btn-sm">Buscar</button>
				</div>

				<div class="col-12" style="font-size: 0.9rem">
					<table class="table pf-table">
						<tr>
							<th class="py-3">Descripción</th>
							<th class="py-3">Seleccionado</th>
						</tr>
						<tr v-for="(item, index) in currentClient.informes" :key="`item_${index}`"> 
							<td class="py-1">
								Bce. {{item.estado}} {{item.ano}} 
							</td>
							<td class="py-1" data-v-step="pf_rf_tabs_2">
								<input type="checkbox" @input="addToClient($event, item)">
							</td>
						</tr>
						<tr>
							<th colspan="2" class="py-3">
								Mostrando desde 1 hasta 3 registros
							</th>
						</tr>
					</table>
				</div>

				<div class="col-12 py-3">
					<div class="d-flex justify-content-end">
						<button class="pf-btn btn btn-primary btn-sm">Borrar</button>
						<button class="pf-btn btn btn-primary btn-sm ml-3" @click="uploadBalance" data-v-step="pf_rf_tabs_3">Cargar</button>
					</div>
				</div>
			</div>
		</pf-modal>
		<pf-modal ref="addAnalysis" :show-close="true" title="Estructura Grupo" class="pf-modal--lg" >
			<div class="p-3" style="min-height: 800px">
				<form @submit.prevent="submitSearch" data-v-step="pf_rf_eg_0">
					<div class="d-flex flex-wrap border-bottom">
						<div class="col-12 col-lg-3">
							<label class="pf-control">	
								<span class="pf-control__label">Búsqueda por</span>
								<select class="pf-control__input pf-control--block">
									<option value="">--Seleccione--</option>
									<option value="Supragrupo">Supragrupo</option>
									<option value="Grupo">Grupo</option>
									<option value="Subgrupo">Subgrupo</option>
									<option value="Cliente/Filial">Cliente/Filial</option>
								</select>
							</label>
						</div>
					
						<div class="col-12 col-lg-9"></div>
					
						<div class="col-12 col-lg-3">
							<label class="pf-control">	
								<span class="pf-control__label">N° Cliente/Grupo</span>
								<input type="text" class="pf-control__input pf-control--block">
							</label>
						</div>
						<div class="col-12 col-lg-3">
							<label class="pf-control">	
								<span class="pf-control__label">Nombre</span>
								<input type="text" class="pf-control__input pf-control--block" v-model="modalNewAnalysis.query">
							</label>
						</div>
						<div class="col-12 col-lg-3">
							<button type="submit" class="btn btn-sm btn-primary" style="font-weight: 300" data-v-step="pf_rf_eg_1">Buscar</button>
						</div>
					</div>
				
				</form>

					<div class="pt-3" v-if="modalNewAnalysis.results.length && !modalNewAnalysis.selectedClient"> 
						<div class="pf-section-gradient mb-2">
							<div class="d-flex">
								<div class="ml-auto d-flex align-items-end">
									<span class="mr-3">Buscar:</span><input type="text" class="border-none">
								</div>
							</div>
						</div>
						<div>
							<table class="table table-borderless w-100" data-v-step="pf_rf_eg_2">
								<tbody style="font-size: 0.8em" class="text-center">
									<tr>
										<th class="pf-section-gradient py-2" style="width: 2rem"></th>
										<th class="pf-section-gradient py-2 text-left" >NOMBRE</th>
										<th class="pf-section-gradient py-2 text-left">CODIGO/CIF</th>
									</tr>
									<tr class="pointer" v-for="(cliente, index) in modalNewAnalysis.results" :key="`cliente_${cliente.id}_${index}`" @click="selectClient(cliente)">
										<td class="px-1">
											<span class="icon-group text-primary" style="font-size: 1.3rem"></span>
										</td>
										<td class="text-left" data-v-step="pf_rf_eg_3">
											{{cliente.nombre}}
										</td>
										<td class="text-left">
											{{cliente.cif}}
										</td>
									</tr>
								</tbody>
							
							</table>

							<div class="pf-section-gradient mb-2">
							<div class="d-flex">
								<div class="ml-auto d-flex align-items-end">
									<span class="px-1 small">Primero</span>
									<span class="px-1 small">Anterior</span>
									<span class="px-1 small">1</span>
									<span class="px-1 small">Siguiente</span>
									<span class="px-1 small">Último</span>
								</div>
							</div>
						</div>
						</div>
					</div>
					<div v-if="modalNewAnalysis.selectedClient" class="diagram" style="min-height: 500px">
						<div class="diagram__item">
							<div class="diagram__title diagram__title--top" @click.prevent="openItem">
								<span class="icon-group text-primary" style="font-size: 1.3rem" data-v-step="pf_rf_eg_4"></span> <span class="text" @click.stop="setClient(modalNewAnalysis.selectedClient)" data-v-step="pf_rf_eg_5"><b>{{modalNewAnalysis.selectedClient.nombre}}</b></span> 
							</div>
							<div class="diagram__item">
								<div class="diagram__title diagram__title--top" @click.prevent="openItem">
									<span class="icon-plus-symbol-button text-primary"></span> <b>Ver todos los participes</b>
								</div>
								<div class="diagram__item" v-for="(filial, index) in modalNewAnalysis.selectedClient.hijos" :key="`filial_${filial.id}_${index}`">
									<div class="diagram__title">
										<span class="icon-user text-primary"></span> <span class="text" @click.stop="setClient(filial)">{{filial.nombre}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div v-if="modalNewAnalysis.clientAnalysis" class="mt-5 py-3 border-top" style="color: #000; font-size: 0.8em">
						<div class="d-flex flex-wrap">
							<div class="col-12 col-md-6">
								Seleccionado: <b>{{modalNewAnalysis.clientAnalysis.nombre}}</b>
							</div>
							<div class="col-12 col-md-3">
								Nivel: <b>{{modalNewAnalysis.clientAnalysis.tipo === 'Grupo' ? 'Grupo' : 'Partícipe'}}</b>
							</div>
							<div class="col-12 col-md-3">
								Entidad: <b>{{modalNewAnalysis.clientAnalysis.entidad}}</b>
							</div>
						</div>

						<div class="d-flex justify-content-center flex-wrap mt-4">
							<div class="col-6 col-md-3">
								<button class="btn btn-primary btn-block rounded w-100" style="font-weight: 300;" @click="addToAnalysis" data-v-step="pf_rf_eg_6">
									Agregar
								</button>
							</div>
						</div>
					</div>
			</div>
		</pf-modal>
		<pf-modal ref="loaderModal" title="Espere">
			<div class="text-center p-2">
				<p>Realizando la operación seleccionada</p>
				<PfLoader />
			</div>
		</pf-modal>
	</div>
</template>

<style lang="scss" scoped>
.pf-control__transparent{
	background: transparent;
	border: 1px solid #ccc;
}
</style>